/*
===============================================================================================================
                                 Copyright 2024-2025, Blue Yonder Group, Inc.
                                              All Rights Reserved

                                THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
                                            BLUE YONDER GROUP, INC.

                            The copyright notice above does not evidence any actual
                                 or intended publication of such source code.

===============================================================================================================
*/

import React from 'react';
import PropTypes from 'prop-types';
import { getStaticCdnPath } from '@/utilities/static-build';

function DecorativeImage({ imageUrl }) {
  return (
    <div>
      <img src={`${getStaticCdnPath()}${imageUrl}`} alt="decorative-element" />
      <style jsx>
        {`
          img {
            width: 100%;
            height: auto;
          }
        `}
      </style>
    </div>
  );
}

DecorativeImage.propTypes = {
  imageUrl: PropTypes.string.isRequired,
};
export default DecorativeImage;
